export default __webpack_public_path__ + "b8f1dd5443177d68be85cf479d45c184.svg";